// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-cap-main {
  margin-top: 1.25rem;
  display: flex;
}
.external-cap-main div {
  flex: 1 1;
  height: 100%;
}
.external-cap-main > div {
  margin-right: 10px;
}
.external-cap-main .p-datatable .p-datatable-thead > tr > th {
  color: #1f54b0;
}
.external-cap-main .highlight-row {
  background: #eef2ff !important;
}
.external-cap-main .cap-table-input {
  width: 2.5rem;
  height: 1.5rem;
  text-align: center;
  border-radius: 0.25rem;
  border: none;
  border: 1.5px solid #c1c0c0;
}
.external-cap-main input:disabled {
  background: rgba(218, 217, 217, 0.523);
}
.external-cap-main .calendar-weekend {
  color: red;
}
.external-cap-main .calendar-weekday,
.external-cap-main .calendar-weekend {
  margin-bottom: 0.5rem;
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 12.5rem;
  font-weight: bold;
}

.main-cap-header {
  display: flex;
  justify-content: start;
  align-items: center;
}
.main-cap-header .supplier.drop {
  width: 20%;
}
.main-cap-header .mr {
  margin-right: 0.5rem;
}
.main-cap-header img,
.main-cap-header label,
.main-cap-header .p-calendar,
.main-cap-header select,
.main-cap-header select.options,
.main-cap-header input {
  cursor: pointer;
}
.main-cap-header .action-buttons,
.main-cap-header .edit-table {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-cap-header .action-buttons {
  flex: 2 1;
  justify-content: end;
}
.main-cap-header .action-buttons > div {
  display: flex;
  justify-content: end;
  align-items: center;
}
.main-cap-header .action-buttons > div > div {
  margin-right: 0.375rem;
}
.main-cap-header .action-buttons.internal {
  flex: 2 1;
}
.main-cap-header .acp-calendar.internal {
  margin-left: 1rem;
}
.main-cap-header .acp-calendar .p-calendar {
  max-height: 2.35rem !important;
  border-radius: 0.25rem;
}
.main-cap-header .acp-calendar .p-inputtext {
  border-radius: 0.25rem;
}
.main-cap-header .acp-calendar .p-button-icon-only {
  height: 25px !important;
  background: transparent;
}
.main-cap-header .acp-calendar .p-button-icon-only img {
  filter: invert(0);
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/ManageCapacity/ManageCapacity.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;AACF;AAAE;EACE,SAAA;EACA,YAAA;AAEJ;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,8BAAA;AAEJ;AAAE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;AAEJ;AAAE;EACE,sCAAA;AAEJ;AAAE;EACE,UAAA;AAEJ;AAAE;;EAEE,qBAAA;AAEJ;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAEF;AADE;EACE,UAAA;AAGJ;AADE;EACE,oBAAA;AAGJ;AADE;;;;;;EAME,eAAA;AAGJ;AADE;;EAEE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;AADE;EACE,SAAA;EACA,oBAAA;AAGJ;AAFI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;AAIN;AAHM;EACE,sBAAA;AAKR;AADE;EACE,SAAA;AAGJ;AADE;EACE,iBAAA;AAGJ;AAAI;EACE,8BAAA;EACA,sBAAA;AAEN;AAAI;EACE,sBAAA;AAEN;AAAI;EACE,uBAAA;EACA,uBAAA;AAEN;AADM;EACE,iBAAA;AAGR","sourcesContent":[".external-cap-main {\n  margin-top: 1.25rem;\n  display: flex;\n  div {\n    flex: 1;\n    height: 100%;\n  }\n  > div {\n    margin-right: 10px;\n  }\n  .p-datatable .p-datatable-thead > tr > th {\n    color: #1f54b0;\n  }\n  .highlight-row {\n    background: #eef2ff !important;\n  }\n  .cap-table-input {\n    width: 2.5rem;\n    height: 1.5rem;\n    text-align: center;\n    border-radius: 0.25rem;\n    border: none;\n    border: 1.5px solid #c1c0c0;\n  }\n  input:disabled {\n    background: rgba(218, 217, 217, 0.523);\n  }\n  .calendar-weekend {\n    color: red;\n  }\n  .calendar-weekday,\n  .calendar-weekend {\n    margin-bottom: 0.5rem;\n  }\n}\n.no-data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 12.5rem;\n  font-weight: bold;\n}\n\n.main-cap-header {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  .supplier.drop {\n    width: 20%;\n  }\n  .mr {\n    margin-right: 0.5rem;\n  }\n  img,\n  label,\n  .p-calendar,\n  select,\n  select.options,\n  input {\n    cursor: pointer;\n  }\n  .action-buttons,\n  .edit-table {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .action-buttons {\n    flex: 2;\n    justify-content: end;\n    > div {\n      display: flex;\n      justify-content: end;\n      align-items: center;\n      > div {\n        margin-right: 0.375rem;\n      }\n    }\n  }\n  .action-buttons.internal {\n    flex: 2;\n  }\n  .acp-calendar.internal {\n    margin-left: 1rem;\n  }\n  .acp-calendar {\n    .p-calendar {\n      max-height: 2.35rem !important;\n      border-radius: 0.25rem;\n    }\n    .p-inputtext {\n      border-radius: 0.25rem;\n    }\n    .p-button-icon-only {\n      height: 25px !important;\n      background: transparent;\n      img {\n        filter: invert(0);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
